import React from 'react';
import PropTypes from 'prop-types';

import { Cover, GridResults, GridResultsVideo, IconsWithText, Layout, Link, SEO, TrustpilotWidget, SectionResultsQuote } from 'components';
import { routes } from 'utils/routes';
import { cta } from 'utils/cta';
import { media } from "utils/media";
import mdToHtml from "utils/mdToHtml"

import contentSeo from "cms/content/reviews-seo.yml";
import contentCover from "cms/content/reviews-cover.yml";
import contentIcons from "cms/content/reviews-icons-with-text.yml";
import contentSelfies from "cms/content/reviews-selfies.yml";
import contentVideos from "cms/content/reviews-videos.yml";
import contentResults from "cms/content/reviews-results-quotes.yml";

const ResultsPage = ({ pageContext: { locale }, location }) => (
  <Layout locale={locale}>
    <SEO
      title={contentSeo.title}
      description={contentSeo.description}
      lang={locale}
      keywords={contentSeo.keywords}
      location={location}
      image={contentSeo.socialImage}
    />

    <Link to={routes.apart.path} {...routes.apart} className='cta-sidetab'>What sets us apart?</Link>

    <Cover
      title={contentCover.title}
      text={mdToHtml(contentCover.text)}
      image={{ url: media(contentCover.image), alt: 'User reviews' }}
      overlap={contentCover.overlap}
      stamp={contentCover.stamp}
      button={{ label: cta.getStarted, ...routes.getStarted }}
      trustpilot={contentCover.trustpilot}
    />

    <IconsWithText content={contentIcons} />


    {contentVideos.enabled && <GridResultsVideo link={{ label: 'View more videos' }} videos={contentVideos.reviews} className='mt-90' />}
    {contentSelfies.enabled && <GridResults link={{ label: 'View more photos' }} pictures={contentSelfies.reviews} />}
    <TrustpilotWidget showReviews />

    <SectionResultsQuote content={contentResults} noButton />
  </Layout>
);

ResultsPage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

export default ResultsPage;
